import { render, staticRenderFns } from "./FileAttachment.vue?vue&type=template&id=f94b3192&scoped=true&"
import script from "./FileAttachment.vue?vue&type=script&lang=js&"
export * from "./FileAttachment.vue?vue&type=script&lang=js&"
import style0 from "./FileAttachment.vue?vue&type=style&index=0&id=f94b3192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94b3192",
  null
  
)

export default component.exports